import { KText } from '@/ui-library/components/text';
import { Avatar, Flex, Box } from '@chakra-ui/react';
import { components } from 'react-select';
import { KTag } from '@/ui-library/components';

export const SelectWithDescriptionOption = (props) => {
  const { data, selectProps = {} } = props;
  const { extraProps = {} } = selectProps;
  const {
    labelKey = 'label',
    descKey = 'desc',
    avatarKey = 'avatar_url',
    showAvatar = false,
    isNearLabel = false,
    enableTooltip = true,
    remoteKey = 'remote',
  } = extraProps;
  const label = data?.[labelKey];
  const desc = data?.[descKey];
  const avatar = data?.[avatarKey];
  const isRemote = data?.[remoteKey];
  const hideAvatar = data?.hideAvatar; // by default it will be false

  return (
    <components.Option {...props}>
      <Flex gap="12px" alignItems="center" width="100%" overflow="hidden">
        {!hideAvatar && showAvatar && (
          <Avatar
            src={avatar}
            name={label}
            width="24px"
            height="24px"
            borderRadius="6px"
            className="avatar-xs"
          />
        )}
        <Box width="100%" overflow="hidden">
          <Flex gap="8px" alignItems="center">
            <KText
              size="sm-semi-bold"
              color="secondary-900"
              isTruncated
              enableTooltip={enableTooltip}
              maxW="300px"
            >
              {label}{' '}
            </KText>
            {isRemote && (
              <KTag
                bg="secondary-25"
                color="secondary-700"
                size="xs-regular"
                value="Remote"
              ></KTag>
            )}
            {desc && isNearLabel ? (
              <KText
                color="secondary-700"
                size="sm-regular"
                isTruncated={enableTooltip}
                enableTooltip={enableTooltip}
                maxW="100%"
              >
                {desc}
              </KText>
            ) : null}
          </Flex>
          {desc && !isNearLabel && (
            <KText
              color="secondary-700"
              size="sm-regular"
              isTruncated={enableTooltip}
              enableTooltip={enableTooltip}
              maxW="100%"
            >
              {desc}
            </KText>
          )}
        </Box>
      </Flex>
    </components.Option>
  );
};
